import { gql } from "graphql-tag";

export const getMatchGQL = gql`
  query GetMatch($getMatchInput: LightMatchInput!) {
    getMatch(getMatchInput: $getMatchInput) {
      matchState
      battleInfo {
        gameId
        battleId
      }
      moment {
        appId
        title
        type
        rankOrder
        app {
          title
        }
      }
      players {
        userId
        playState
        score
        user {
          id
          avatar
          username
          xp
        }
      }
      winners {
        rank
        userId
      }
      expiryTime
      winAmount
      hostUserId
    }
  }
`;

export const getHouseMatchGQL = gql`
  query GetHouseMatch($matchId: String!) {
    getHouseMatch(matchId: $matchId) {
      matchState
      battleInfo {
        gameId
        battleId
      }
      moment {
        appId
        title
        type
        time
        id
        rankOrder
        app {
          title
        }
      }
      players {
        userId
        playState
        score
        user {
          id
          avatar
          username
          xp
        }
      }
      winners {
        rank
        userId
      }
      expiryTime
      winAmount
    }
  }
`;

export const userHouseBattlesGQL = gql`
  query userHouseBattles($restrictToRecommended: Boolean!) {
    userHouseBattles(restrictToRecommended: $restrictToRecommended) {
      matchId
      matchState
      host {
        id
        username
        avatar
        xp
      }
      game {
        id
        title
        description
        category
        data
        timesPlayed
        rotationMode
        status
        type
      }
      scoreToBeat
      prize
      winType
      createdAt
    }
  }
`;
